import React, { useState, useEffect } from "react";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";

import axios from "axios";
import API_GATEWAY_URL from '../../config';

function BlockNameInput({ label, filter_type, setSelectedValue, setTargetEmail }) {
    const [blockOptions, setBlockOptions] = useState([]);

    useEffect(() => {
        const jwt_token = localStorage.getItem('palm_care_token');
        const apiUrl = `${API_GATEWAY_URL}/${filter_type}s`;
        const headers = {
            Authorization: jwt_token
        };
        axios.get(apiUrl, { headers })
            .then((response) => {
                setBlockOptions(response.data[filter_type+"s"]);
            })
            .catch((error) => {
                console.error("Error fetching block data:", error);
            });
    }, []);

    const handleAutocompleteChange = (event, newValue) => {
        if (typeof newValue === 'object' && newValue !== null) {
            setSelectedValue(newValue[filter_type] || "");
            if (setTargetEmail) setTargetEmail(newValue.target_email || "");
        } else {
            setSelectedValue(newValue || "");
        }
    };

    const handleAutoCompleteBlur = (event) => {
        setSelectedValue(event.target.value);
    };

    return (
        <Autocomplete
            freeSolo
            options={blockOptions}
            getOptionLabel={(option) => typeof option === 'object' ? option[filter_type] : option}
            renderInput={(params) => (
                <TextField {...params} label={label} />
            )}
            autoHighlight
            onChange={handleAutocompleteChange}
            onBlur={handleAutoCompleteBlur}
            style={{ width: '300px', margin: '0px 30px 20px 0px' }}
        />

    );
}

export default BlockNameInput;
